module.exports = __webpack_public_path__ + "img/Z60Q_04.57b76a6c.jpg";